/* Types */
import { Bounds } from '@/api/modules/geo/geocode.types'

export const TIME_OF_DEBOUNCE = 500

export const COUNT_OF_QUERY = 3

/**
 * Ограничения по поиску подсказок
 */
export const BOUND_OF_SEARCH_AUTOCOMPLETE: Record<string, Bounds> = {
  STREET: 'street',
  HOUSE: 'house',
}

/**
 * Текстовые описания ошибок автокомплита
 */
export const StateOfAutocomplete = {
  NOT_FOUND: 'Не удалось найти адрес',
  NOT_DETECTED: 'Не удалось определить адрес',
  EMPTY: 'Укажите адрес или определите местоположение',
  BAN_GEO: 'Вы запретили определение местоположения',
  TO_MANY_REQUEST: 'Слишком много запросов. Попробуйте позже',
  NOT_WORKING: 'Поиск адреса временно не работает',
  NOT_COORDS: 'Не удалось определить позицию адреса. Попробуйте еще раз',
  NOT_STREET: 'Адрес не содержит улицу',
  NOT_VALID_ADDRESS: 'Укажите адрес с номером дома',
  NOT_SAVE_ADDRESS: 'Не удалось сохранить адрес, попробуйте позже',
  NOT_DETECTED_CITY: 'Не удалось определить город',
  BAN_GEO_CITY:
    'Не удается определить ваше местоположение — разрешите доступ в настройках браузера или введите адрес вручную',
}
